import React from 'react';
import './about.css';
import DP from '../../Assets/profile.webp';
import { ReactTyped } from 'react-typed';

const STATS = [
  { value: '9+', label: 'Years of Experience' },
  { value: '2K+', label: 'Events Captured' },
  { value: '500+', label: 'Happy Clients' }
];

const About = () => {
  return (
    <section className="about-section" id="About">

      {/* ── SECTION HEADER ── */}
      <div className="about-header">
        <span className="about-eyebrow">Our Story</span>
        <h2 className="about-title">About Us</h2>
        <div className="about-title-ornament">
          <span />
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#C9A84C">
            <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4z"/>
          </svg>
          <span />
        </div>
      </div>

      {/* ── MAIN CONTENT GRID ── */}
      <div className="about-grid">

        {/* LEFT — Profile photo */}
        <div className="about-photo-col">
          <div className="photo-frame-outer">
            <div className="photo-frame-inner">
              <img src={DP} alt="Dhavan Gadiwala — Founder" className="about-dp" />
              {/* Corner accents */}
              <span className="frame-corner fc-tl" />
              <span className="frame-corner fc-tr" />
              <span className="frame-corner fc-bl" />
              <span className="frame-corner fc-br" />
            </div>
            {/* Floating badge */}
            <div className="photo-badge">
              <span className="badge-year">Est.</span>
              <span className="badge-num">2017</span>
              <span className="badge-city">Surat</span>
            </div>
          </div>

          {/* Founder card below photo */}
          <div className="founder-card">
            <div className="founder-name">Dhavan Gadiwala</div>
            <ReactTyped
              className="founder-role"
              strings={["Founder", "Photographer", "Cinematographer", "Editor"]}
              typeSpeed={90}
              backSpeed={40}
              loop
              cursorChar="|"
              showCursor
            />
          </div>
        </div>

        {/* RIGHT — Text content */}
        <div className="about-text-col">

          <p className="about-greeting">Hello, We are <strong>Shree Photos Films</strong></p>

          <p className="about-body">
            Shree Photo Films has been serving the metro area since <strong>2017</strong>. Founded by <strong>Dhavan Gadiwala</strong>, we provide all types of Photography &amp; Videography with professional editing services — making every event unforgettable.
          </p>

          <p className="about-body">
            Our team of multiple skilled photographers is dedicated to turning your precious moments into timeless memories that you'll cherish forever.
          </p>

          {/* Quote */}
          <blockquote className="about-quote">
            <span className="quote-mark">"</span>
            Photography is the art of capturing light with a twist of passion, turning moments into memories.
            <span className="quote-mark">"</span>
          </blockquote>

          {/* CTA */}
        </div>
      </div>

      {/* ── STATS STRIP ── */}
      <div className="about-stats">
        {STATS.map(({ value, label }) => (
          <div key={label} className="stat-item">
            <span className="stat-value">{value}</span>
            <span className="stat-label">{label}</span>
          </div>
        ))}
      </div>

    </section>
  );
};

export default About;